const sv = {
  nav: {
    company: "Företag",
    overview: "Företagsöversikt",
    allServices: "Alla tjänster",
    arbetsmiljo: "Arbetsmiljö",
    drogtestning: "Drogtestning",
    tjanster: "Alla tjänster",
    kontakt: "Kontakt",
    bokaTid: "Boka tid",
    otherCertificates: "Övriga intyg",
    healthChecks: "Hälsokontroller",
    about: "Om oss",
  },
  shared: {
    forCompanies: "För företag",
    contactEyebrow: "Kontakt för arbetsgivare",
    contactDefaultTitle: "Vi planerar utifrån ert behov",
    contactText:
      "Berätta vilka tjänster ni behöver, för hur många personer och när. Vi återkommer med upplägg, pris och tider.",
    inquiryCta: "Skicka företagsförfrågan",
    bookEmployee: "Boka en medarbetare",
    bookDirect: "Boka tid direkt",
    sendInquiry: "Skicka förfrågan",
    planSeveral: "Planera flera personer",
    requirements: "Krav och förberedelser",
    readMore: "Läs om tjänsten",
    companyInquiry: "Förfrågan för företaget",
    quoteCta: "Begär offert",
    quotePrice: "Kontakta oss för offert",
    assuranceMroTitle: "Alla drogprover granskas av MRO-läkare",
    assuranceMroText: "Medicinsk granskning av provresultatet.",
    assuranceLabTitle: "Laboratorieanalys via Unilabs",
    assuranceLabText: "Vår samarbetspartner för drogprover.",
    sourcesChecked: "Informationen kontrollerades den 9 september 2026.",
  },
  arbetsmiljo: {
    metaTitle: "Arbetsmiljökontroller för företag i Göteborg | Intygsläkaren",
    metaDescription:
      "Boka handintensivt arbete, vibrationer och nattarbete direkt. Skicka förfrågan för kemikalier, asbest, kvarts, bly och klättring.",
    label: "Arbetsmiljö",
    title: "Medicinska kontroller för er arbetsplats",
    subtitle:
      "Vi hjälper er att planera kontroller utifrån arbetsmoment, exponering och gällande krav. Boka enskilda besök direkt för handintensivt arbete, vibrationer och nattarbete, eller kontakta oss för att samordna flera medarbetare.",
    directEyebrow: "Boka direkt",
    directTitle: "Tre kontroller med direktbokning",
    plannedEyebrow: "Vi planerar tillsammans",
    plannedTitle: "Övriga arbetsmiljökontroller",
    plannedIntro:
      "Skicka en företagsförfrågan så går vi igenom underlag, eventuella kompletterande undersökningar och tider innan något bokas.",
    sourcesBefore: "Läs om vilka arbeten som omfattas och när kontroll behövs på respektive undersida. Faktaunderlag:",
    sourcesLink: "Arbetsmiljöverkets AFS 2023:15",
  },
  drogtestning: {
    metaTitle: "Drogtestning för företag – Unilabs och MRO | Intygsläkaren",
    metaDescription:
      "Drogtestning som förebyggande hälsovård, vid nyanställning och vid misstanke. Alla drogprover granskas av MRO. Kontakta oss för offert.",
    label: "Drogtestning",
    title: "Drogtestning för en tryggare arbetsplats",
    subtitle:
      "Vi erbjuder drogtestning som en del av företagets förebyggande hälsovård och arbetsmiljöarbete. Vi hjälper er vid nyanställning och vid misstanke, med planerad provtagning, analys i samarbete med Unilabs och MRO-granskning av alla drogprover. Kontakta oss för offert.",
    processLink: "Så granskas proverna",
    casesTitle: "När behöver ert företag hjälp?",
    casePreventiveEyebrow: "Förebyggande hälsovård",
    casePreventiveTitle: "Planerad drogtestning",
    casePreventiveText:
      "Ett genomtänkt upplägg utifrån företagets verksamhet, drogpolicy och förutsättningarna för testning. Vi går igenom behov och provtagning tillsammans.",
    casePreventiveCta: "Planera med oss",
    caseHireEyebrow: "Vid nyanställning",
    caseHireTitle: "Inför anställningsstart",
    caseHireText:
      "Planera provtagningen i god tid, med tydlig information till kandidaten och medicinsk granskning före återkoppling.",
    caseHireCta: "Läs om nyanställning",
    caseSuspicionEyebrow: "Vid misstanke",
    caseSuspicionTitle: "När ni behöver agera",
    caseSuspicionText:
      "Kontakta oss för att bedöma möjligheten till provtagning. Tid och plats bekräftas efter kontakt med mottagningen.",
    caseSuspicionCta: "Läs om misstanke",
    sampleEyebrow: "Välj provtyp",
    sampleTitle: "Salivtest eller urinprov",
    sampleIntro:
      "Kontakta oss för offert. Vi planerar provtyp, analyser och MRO-granskning utifrån företagets behov.",
    sampleSalivCta: "Begär offert för salivtest",
    sampleUrinCta: "Begär offert för urinprov",
    processTitle: "Från provtagning till granskat svar",
    processP1:
      "Vi planerar provtyp och analyser utifrån frågeställningen. Provet hanteras enligt rutiner för arbetsplatsprover och analyseras hos Unilabs. Ett preliminärt positivt screeningresultat behöver verifieras med en specifik laboratorieanalys.",
    processP2:
      "Alla drogprover granskas av en MRO-läkare, Medical Review Officer. Det är en läkare med särskild utbildning i att tolka drogtestresultat och bedöma medicinska förklaringar, till exempel ordinerade läkemedel.",
    processReadMore: "Läs hela processen",
    agreeTitle: "Vi kommer överens om",
    agreeItems: [
      "Syfte, antal personer och vilka analyser som behövs.",
      "Provtagningsplats, instruktioner och tid.",
      "Pris och beräknad svarstid.",
      "Behörig mottagare och hur återkopplingen sker.",
    ],
    privacyTitle: "Information och integritet före provtagning",
    privacyText:
      "Testningen behöver ha stöd i de regler och avtal som gäller för er verksamhet. Berörda personer ska få tydlig information om syftet och hur resultatet hanteras. Medicinska uppgifter lämnas till vården; i företagsformuläret räcker kontaktuppgifter och en beskrivning av ert behov.",
    ctaTitle: "Planera företagets drogtestning",
    hireSectionTitle: "Drogtestning inför en ny anställning",
    hireSectionText:
      "Planera provtagningen inför anställningsstart som en del av företagets förebyggande hälso- och arbetsmiljöarbete. Vi samordnar provtagning, laboratorieanalys via Unilabs och MRO-granskning.",
    suspicionSectionTitle: "Drogtestning vid misstanke på arbetsplatsen",
    suspicionSectionText:
      "När det finns misstanke om droganvändning hjälper vi er att planera provtagning och medicinsk bedömning. Proverna analyseras i samarbete med Unilabs och granskas av MRO-läkare.",
    processDetailTitle: "Från drogprov till medicinskt granskat svar",
    processSteps: [
      {
        title: "1. Beställning och provtagning",
        text: "Vi kommer överens om syfte, analyser, antal personer och provtagningsplats. Drogprover kan analyseras i urin eller saliv. Identiteten kontrolleras och provet tas enligt rutiner för arbetsplatsprover.",
      },
      {
        title: "2. Laboratorieanalys hos Unilabs",
        text: "Unilabs utför analysen. Ett preliminärt positivt screeningresultat bekräftas med en specifik analysmetod. Vilka substanser som ingår bestäms vid beställningen.",
      },
      {
        title: "3. Alla drogprover granskas av MRO",
        text: "MRO står för Medical Review Officer: en läkare med särskild utbildning i att granska och tolka drogtestresultat. Vid avvikande resultat bedöms bland annat ordinerade läkemedel.",
      },
      {
        title: "4. Återkoppling med respekt för integriteten",
        text: "Vi bestämmer i förväg vem som får ta emot återkopplingen. Medicinska uppgifter hanteras inom vården. Pris och svarstid beror på provtyp och analyspaket.",
      },
    ],
    sourcesPrefix: "Faktaunderlag om analys och medicinsk granskning:",
    sourcesUnilabs: "Unilabs – droganalyser",
    sourcesInstructions: "Unilabs provtagningsanvisningar",
    sourcesMro: "Karolinska – MRO",
    sourcesFaq: "frågor och svar om drogtestning",
    sourcesPrivacy: "IMY – kontroll av anställda",
    callCta: "Ring 031-761 77 00",
  },
  tjanster: {
    metaTitle: "Alla tjänster för företag | Intygsläkaren",
    metaDescription:
      "Läkarintyg, medicinska kontroller och drogtestning för företag. Boka en medarbetare direkt eller skicka en förfrågan för flera personer och samordning.",
    label: "Alla tjänster",
    title: "Våra tjänster, samlade för företag",
    subtitle:
      "Här finns hela vårt utbud av läkarintyg och medicinska kontroller, plus drogtestning för arbetslivet. Boka enskilda besök direkt när tjänsten erbjuds för bokning, eller skicka en företagsförfrågan för flera medarbetare och samordning.",
    categoriesAria: "Tjänstekategorier",
    drugNav: "Drogtestning för företag",
    drugTitle: "Drogtestning för företag",
    drugText:
      "Förebyggande hälsovård, vid nyanställning och vid misstanke. Alla drogprover granskas av MRO-läkare. Vi samarbetar med Unilabs för analysen.",
    drugReadMore: "Läs om drogtestning",
    drugOverrideIntro:
      "Drogtestning för företag med analys via Unilabs och MRO-granskning. Kontakta oss för offert.",
    ctaTitle: "Behöver ni flera olika tjänster?",
  },
  kontakt: {
    metaTitle: "Företagsförfrågan – planera intyg och drogtestning | Intygsläkaren",
    metaDescription:
      "Skicka en förfrågan om läkarintyg, medicinska kontroller eller drogtestning. Vi återkommer via e-post om upplägg, pris och tider.",
    label: "Kontakt",
    title: "Vad behöver ert företag hjälp med?",
    subtitle:
      "Skicka en förfrågan om läkarintyg, medicinska kontroller eller drogtestning. Vi går igenom ert behov och återkommer via e-post om upplägg, pris och tider.",
    formEyebrow: "Företagsförfrågan",
    formTitle: "Berätta vad ni behöver",
    formSubtitle: "Välj en eller flera tjänster och beskriv företagets behov, så planerar vi tillsammans.",
    servicesLegend: "Vilken tjänst gäller det?",
    servicesPlaceholder: "Välj en eller flera tjänster",
    servicesSelectedOne: "1 tjänst vald",
    servicesSelectedMany: "{count} tjänster valda",
    servicesDone: "Klar",
    servicesHelp: "Hjälp oss att välja rätt tjänster",
    servicesError: "Välj minst en tjänst eller bocka i att ni vill ha hjälp.",
    drugGroup: "Drogtestning för företag",
    sampleLabel: "Önskad provtyp för drogtestning",
    sampleHelp: "Hjälp att välja provtyp",
    sampleSaliv: "Salivtest",
    sampleUrin: "Urinprov",
    urgentNote: "Behöver ni provtagning skyndsamt?",
    urgentCall: "Ring 031-761 77 00",
    urgentRest: "för att stämma av möjligheten. Tid och plats bekräftas efter kontakt.",
    contactPerson: "Kontaktperson",
    company: "Företag eller organisation",
    email: "E-post",
    phoneOptional: "Telefonnummer (valfritt)",
    peopleCount: "Antal personer",
    workplace: "Arbetsplats eller ort (valfritt)",
    workplacePlaceholder: "Var utförs arbetet?",
    period: "Önskad period eller datum (valfritt)",
    periodPlaceholder: "Exempel: före anställningsstart den 1 november",
    description: "Beskriv företagets behov",
    descriptionPlaceholder:
      "Vilka tjänster behövs och när? Beskriv upplägget ni önskar utan uppgifter om enskilda medarbetares hälsa.",
    privacy:
      "Ange bara företagets behov och kontaktpersonens uppgifter. Namn på den som ska drogtestas, personnummer, provsvar och hälsouppgifter lämnas senare genom vårdens kontaktvägar.",
    consent: "Jag godkänner att Intygsläkaren behandlar mina uppgifter för att besvara förfrågan.",
    submit: "Skicka förfrågan",
    submitHint: "Vi återkommer via e-post om upplägg, pris och tid.",
    nextTitle: "Efter er förfrågan",
    nextSteps: [
      "Vi går igenom de tjänster ni behöver.",
      "Vi återkommer via e-post med frågor eller ett förslag på upplägg.",
      "Ni får besked om pris och tider innan besöken bokas.",
    ],
    nextNote: "Besök och provtagning bokas efter att vi har kommit överens om upplägget.",
    successTitle: "Vi har fått er förfrågan",
    successText:
      "Vi återkommer via e-post för att gå igenom underlag, undersökningar, pris och tider. Ni behöver inte skicka samma förfrågan igen.",
    successSample: "Önskad provtyp:",
    successNote: "Besök och provtagning är bokade först när vi har bekräftat upplägget tillsammans med er.",
  },
  bokaTid: {
    metaTitle: "Boka tid för medarbetare | Intygsläkaren",
    metaDescription:
      "Boka läkarintyg eller medicinsk kontroll för en medarbetare. För flera personer eller samordning, skicka en företagsförfrågan.",
    label: "Boka tid",
    title: "Boka ett besök för en medarbetare",
    subtitle:
      "Välj intyg eller kontroll. Därefter bokar du en ledig tid. För flera medarbetare eller samordnad provtagning kan ni skicka en företagsförfrågan.",
    inquiryLink: "Flera medarbetare eller hjälp att välja? Skicka en förfrågan",
    bookVisit: "Boka besök",
    bookingTitle: "Välj tid för",
    bookingHelp: "Öppna bokningen i iframe-fönstret och följ stegen för att välja tid.",
    backToList: "Välj en annan tjänst",
  },
};

const en: typeof sv = {
  nav: {
    company: "Companies",
    overview: "Business overview",
    allServices: "All services",
    arbetsmiljo: "Occupational health",
    drogtestning: "Drug testing",
    tjanster: "All services",
    kontakt: "Contact",
    bokaTid: "Book appointment",
    otherCertificates: "Other certificates",
    healthChecks: "Health checks",
    about: "About us",
  },
  shared: {
    forCompanies: "For companies",
    contactEyebrow: "Contact for employers",
    contactDefaultTitle: "We plan around your needs",
    contactText:
      "Tell us which services you need, for how many people and when. We will get back with a setup, pricing and times.",
    inquiryCta: "Send a company inquiry",
    bookEmployee: "Book for an employee",
    bookDirect: "Book directly",
    sendInquiry: "Send inquiry",
    planSeveral: "Plan for several people",
    requirements: "Requirements and preparation",
    readMore: "Read about the service",
    companyInquiry: "Company inquiry",
    quoteCta: "Request a quote",
    quotePrice: "Contact us for a quote",
    assuranceMroTitle: "All drug tests are reviewed by an MRO physician",
    assuranceMroText: "Medical review of the test result.",
    assuranceLabTitle: "Laboratory analysis via Unilabs",
    assuranceLabText: "Our partner for drug testing samples.",
    sourcesChecked: "Information checked on 9 September 2026.",
  },
  arbetsmiljo: {
    metaTitle: "Occupational medical examinations for businesses | Intygsläkaren",
    metaDescription:
      "Book hand-intensive work, vibration and night work medicals directly. Enquire about chemicals, asbestos, silica, lead and climbing examinations.",
    label: "Occupational health",
    title: "Medical examinations for your workplace",
    subtitle:
      "We help you plan examinations based on work tasks, exposure and applicable requirements. Book individual visits directly for hand-intensive work, vibrations and night work, or contact us to coordinate several employees.",
    directEyebrow: "Book directly",
    directTitle: "Three examinations with direct booking",
    plannedEyebrow: "We plan together",
    plannedTitle: "Other occupational health examinations",
    plannedIntro:
      "Send a company inquiry and we will review documentation, any complementary examinations and times before anything is booked.",
    sourcesBefore:
      "Read about which jobs are covered and when an examination is needed on each service page. Source:",
    sourcesLink: "Swedish Work Environment Authority AFS 2023:15",
  },
  drogtestning: {
    metaTitle: "Business drug testing – Unilabs and MRO | Intygsläkaren",
    metaDescription:
      "Preventive, pre-employment and reasonable suspicion drug testing. All drug samples are reviewed by an MRO doctor. Contact us for a quote.",
    label: "Drug testing",
    title: "Drug testing for a safer workplace",
    subtitle:
      "We offer drug testing as part of your company's preventive health and occupational safety work. We help with hiring and reasonable suspicion cases, with planned sampling, Unilabs analysis and MRO review of all drug samples. Contact us for a quote.",
    processLink: "How samples are reviewed",
    casesTitle: "When does your company need help?",
    casePreventiveEyebrow: "Preventive healthcare",
    casePreventiveTitle: "Planned drug testing",
    casePreventiveText:
      "A thoughtful setup based on your operations, drug policy and testing conditions. We review needs and sampling together.",
    casePreventiveCta: "Plan with us",
    caseHireEyebrow: "At hiring",
    caseHireTitle: "Before employment starts",
    caseHireText:
      "Plan sampling in good time, with clear information to the candidate and medical review before feedback.",
    caseHireCta: "Read about hiring",
    caseSuspicionEyebrow: "Reasonable suspicion",
    caseSuspicionTitle: "When you need to act",
    caseSuspicionText:
      "Contact us to assess whether sampling is possible. Time and place are confirmed after contacting the clinic.",
    caseSuspicionCta: "Read about suspicion cases",
    sampleEyebrow: "Choose sample type",
    sampleTitle: "Saliva or urine test",
    sampleIntro:
      "Contact us for a quote. We plan sample type, analyses and MRO review based on your company's needs.",
    sampleSalivCta: "Request a quote for saliva testing",
    sampleUrinCta: "Request a quote for urine testing",
    processTitle: "From sampling to reviewed result",
    processP1:
      "We plan sample type and analyses based on the question. The sample is handled according to workplace testing routines and analysed at Unilabs. A preliminary positive screening result needs verification with a specific laboratory analysis.",
    processP2:
      "All drug samples are reviewed by an MRO physician (Medical Review Officer) — a doctor specially trained to interpret drug test results and assess medical explanations such as prescribed medication.",
    processReadMore: "Read the full process",
    agreeTitle: "We agree on",
    agreeItems: [
      "Purpose, number of people and which analyses are needed.",
      "Sampling location, instructions and timing.",
      "Price and estimated turnaround time.",
      "Authorised recipient and how feedback is given.",
    ],
    privacyTitle: "Information and privacy before sampling",
    privacyText:
      "Testing needs support in the rules and agreements that apply to your organisation. Affected people should receive clear information about the purpose and how the result is handled. Medical details are given to healthcare; the company form only needs contact details and a description of your need.",
    ctaTitle: "Plan your company's drug testing",
    hireSectionTitle: "Drug testing before a new employment",
    hireSectionText:
      "Plan sampling before employment starts as part of your preventive health and occupational safety work. We coordinate sampling, Unilabs laboratory analysis and MRO review.",
    suspicionSectionTitle: "Drug testing on reasonable suspicion",
    suspicionSectionText:
      "When there is suspicion of drug use, we help you plan sampling and medical assessment. Samples are analysed with Unilabs and reviewed by an MRO physician.",
    processDetailTitle: "From drug sample to medically reviewed result",
    processSteps: [
      {
        title: "1. Order and sampling",
        text: "We agree on purpose, analyses, number of people and sampling location. Drug samples can be analysed in urine or saliva. Identity is checked and the sample is taken according to workplace testing routines.",
      },
      {
        title: "2. Laboratory analysis at Unilabs",
        text: "Unilabs performs the analysis. A preliminary positive screening result is confirmed with a specific method. Which substances are included is decided when ordering.",
      },
      {
        title: "3. All drug samples are reviewed by MRO",
        text: "MRO means Medical Review Officer: a physician specially trained to review and interpret drug test results. Abnormal results are assessed including possible prescribed medication.",
      },
      {
        title: "4. Feedback with respect for privacy",
        text: "We decide in advance who receives feedback. Medical details stay within healthcare. Price and turnaround depend on sample type and analysis package.",
      },
    ],
    sourcesPrefix: "Sources on analysis and medical review:",
    sourcesUnilabs: "Unilabs – drug analyses",
    sourcesInstructions: "Unilabs sampling instructions",
    sourcesMro: "Karolinska – MRO",
    sourcesFaq: "FAQ on drug testing",
    sourcesPrivacy: "IMY – employee monitoring",
    callCta: "Call 031-761 77 00",
  },
  tjanster: {
    metaTitle: "All business services | Intygsläkaren",
    metaDescription:
      "Medical certificates, examinations and drug testing for businesses. Book one employee directly or enquire about arrangements for multiple employees.",
    label: "All services",
    title: "Our services, gathered for companies",
    subtitle:
      "Here is our full range of medical certificates and occupational examinations, plus workplace drug testing. Book individual visits when direct booking is available, or send a company inquiry for several employees and coordination.",
    categoriesAria: "Service categories",
    drugNav: "Drug testing for companies",
    drugTitle: "Drug testing for companies",
    drugText:
      "Preventive healthcare, at hiring and on reasonable suspicion. All drug samples are reviewed by an MRO physician. We partner with Unilabs for analysis.",
    drugReadMore: "Read about drug testing",
    drugOverrideIntro:
      "Company drug testing with Unilabs analysis and MRO review. Contact us for a quote.",
    ctaTitle: "Need several different services?",
  },
  kontakt: {
    metaTitle: "Company inquiry – plan certificates and drug testing | Intygsläkaren",
    metaDescription:
      "Send an inquiry about medical certificates, occupational examinations or drug testing. We reply by email with a setup, pricing and times.",
    label: "Contact",
    title: "What does your company need help with?",
    subtitle:
      "Send an inquiry about medical certificates, occupational examinations or drug testing. We review your needs and reply by email with a setup, pricing and times.",
    formEyebrow: "Company inquiry",
    formTitle: "Tell us what you need",
    formSubtitle: "Choose one or more services and describe your company's needs, and we will plan together.",
    servicesLegend: "Which service is this about?",
    servicesPlaceholder: "Choose one or more services",
    servicesSelectedOne: "1 service selected",
    servicesSelectedMany: "{count} services selected",
    servicesDone: "Done",
    servicesHelp: "Help us choose the right services",
    servicesError: "Choose at least one service or tick that you want help choosing.",
    drugGroup: "Drug testing for companies",
    sampleLabel: "Preferred sample type for drug testing",
    sampleHelp: "Help choosing sample type",
    sampleSaliv: "Saliva test",
    sampleUrin: "Urine test",
    urgentNote: "Need sampling urgently?",
    urgentCall: "Call 031-761 77 00",
    urgentRest: "to check availability. Time and place are confirmed after contact.",
    contactPerson: "Contact person",
    company: "Company or organisation",
    email: "Email",
    phoneOptional: "Phone number (optional)",
    peopleCount: "Number of people",
    workplace: "Workplace or location (optional)",
    workplacePlaceholder: "Where is the work carried out?",
    period: "Preferred period or date (optional)",
    periodPlaceholder: "Example: before employment starts on 1 November",
    description: "Describe your company's needs",
    descriptionPlaceholder:
      "Which services are needed and when? Describe the setup you want without details about individual employees' health.",
    privacy:
      "Only include the company's needs and the contact person's details. Names of people to be drug-tested, personal identity numbers, test results and health information are provided later through healthcare channels.",
    consent: "I agree that Intygsläkaren processes my details to respond to this inquiry.",
    submit: "Send inquiry",
    submitHint: "We will reply by email about setup, price and timing.",
    nextTitle: "After your inquiry",
    nextSteps: [
      "We review the services you need.",
      "We reply by email with questions or a proposed setup.",
      "You get pricing and times before visits are booked.",
    ],
    nextNote: "Visits and sampling are booked after we have agreed on the setup.",
    successTitle: "We have received your inquiry",
    successText:
      "We will reply by email to go through documentation, examinations, pricing and times. You do not need to send the same inquiry again.",
    successSample: "Preferred sample type:",
    successNote: "Visits and sampling are booked only once we have confirmed the setup with you.",
  },
  bokaTid: {
    metaTitle: "Book an appointment for an employee | Intygsläkaren",
    metaDescription:
      "Book a medical certificate or occupational examination for one employee. For several people or coordination, send a company inquiry.",
    label: "Book appointment",
    title: "Book a visit for an employee",
    subtitle:
      "Choose a certificate or examination, then book an available time. For several employees or coordinated sampling, you can send a company inquiry.",
    inquiryLink: "Several employees or need help choosing? Send an inquiry",
    bookVisit: "Book visit",
    bookingTitle: "Choose a time for",
    bookingHelp: "Use the booking window below and follow the steps to pick a time.",
    backToList: "Choose another service",
  },
};

export const companyPages = { sv, en };
